const state = {

    serverIp    : 'localhost',
    serverPort  : 8001,
    Loading     : false,
    Progress    : 0,
    Access_Tabs : []
    
  }
  
  const mutations = {
      SetProgress(state,payload){
        state.Progress = payload
      },
      SetLoading(state,payload){
        state.Loading = payload
      },
      SetTabs(state,payload){
        state.Access_Tabs = payload
      }
  }
  
  const actions = {
      
  }
  
  const getters = {

      GetProductionUrl(){
        
        if(process.env.NODE_ENV == 'development'){

            return 'http://localhost:8001' 

        }else{

            return 'https://api.prwatech.com'

        }
      },
      GetLoading(state){
        return state.Loading 
      },
      GetAccessTabs(state){
        return state.Access_Tabs
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  